module.exports = __webpack_public_path__ + "img/1.07.thmb.xs.25067047.jpg";